module.exports = __webpack_public_path__ + "static/customselectors2-b9af106129b700486911dfdf7a1f5ab4.png";